// Copyright (c) Docugami, Inc. All rights reserved.
import { ZIndices } from 'components/shell/presentation/AppStyles';
import { useEffect, useState } from 'react';

import styled from 'styled-components';

const LoaderContainer = styled.div<{bgColor: string}>`
    width: 100%;
    height: 100%;
    z-index: ${ZIndices.StatusBar};
    .loader {
        height: 80%;
        width: 100%;
        background-color: ${props => props.bgColor};
        padding: 2% 2% 2% 2%;
    }
    .loader-bar {
        background-color: #A3F090;
        height: 100%;
        min-height: 5px;
        max-width: 100%;
        transition: width 0.5s;
    }
`;

/**
 * Creates a status bar governed by either a percentage of completion
 * or animated to fill up and then reset to imply progress
 * @param progress The percentage of progress completed.  Only relevant if isInfinite is false.
 * @param isInfinite Whether or not the status bar should be animated to fill and empty.
 */
export const StatusBar = ({ progress=0, isInfinite=false, bgColor="#FFFFFF" } : {progress?: number, isInfinite?: boolean, bgColor?: string}) => {

    const [amount, setAmount] = useState(0);

    function barWidth() {
        if (!isInfinite) {
            return progress;
        }
        return amount;
    }

    useEffect(() => {
        if (isInfinite) {
            let timer = window.setTimeout(function() {
                if (amount < 100) {
                    setAmount(amount + 5);
                } else {
                    window.clearTimeout(timer);
                    setAmount(0);
                }
            }, 200);
            return () => {window.clearTimeout(timer)}
        }
    }, [amount, isInfinite])

    return (
        <LoaderContainer bgColor={bgColor}>
            <div className="loader">
                <div className="loader-bar" style={{width: `${barWidth()}%`}}/>
            </div>
        </LoaderContainer>
    )
}

export default StatusBar;
